{
  "alert_examples": {
    "camera_offline": "Samarqand kamerasi 25 daqiqadan beri ishlamayapti.",
    "cancelled_spike": "Eshikdan qaytganlar ulushi odatdagidan 2 barobar ko'p.",
    "early_close": "Do'kon rejadan 15 daqiqa erta yopildi.",
    "flow_drop": "Riviera bugun 14:00 gacha o'tgan 4 payshanba o'rtachasidan 35% past.",
    "late_open": "City Mall bugun 10:24 da ochildi (odatda 10:00).",
    "no_data": "Samarqand kamerasidan 30 daqiqa davomida ma'lumot kelmadi.",
    "record": "Riviera: 90 kundagi eng ko'p tashrif (318).",
    "target_progress": "Oylik maqsadning 82% i bajarildi, oy tugashiga 5 kun bor."
  },
  "alert_kinds": {
    "agent_alert": "Server ogohlantirishi",
    "camera_offline": "Kamera oflayn",
    "cancelled_spike": "Kirmay qaytganlar ko'paydi",
    "control_summary": "Nazorat: soatlik xulosa",
    "customer_unattended": "Mijozlar xodimsiz qoldi",
    "store_no_staff": "Do'konda xodim yo'q",
    "disk_pressure": "Disk to'lmoqda",
    "early_close": "Erta yopildi",
    "flow_drop": "Oqim keskin tushdi",
    "late_open": "Kech ochildi",
    "long_wait": "Mijoz uzoq kutdi",
    "no_data": "Ma'lumot kelmayapti",
    "post_empty": "Post bo'sh",
    "record": "Rekord",
    "release_failed": "Sozlamalarni qo'llab bo'lmadi",
    "report_not_sent": "Hisobot yuborilmadi",
    "scheduled_task_failed": "Rejalashtirilgan vazifa bajarilmadi",
    "security": "Xavfsizlik hodisasi",
    "server_offline": "Server oflayn",
    "staff_gathering": "Xodimlar to'planib qoldi",
    "staff_phone": "Xodim telefonda",
    "target_progress": "Maqsad"
  },
  "alert_severities": {
    "critical": "Muhim",
    "info": "Ma'lumot",
    "warning": "Ogohlantirish"
  },
  "alerts": {
    "bell_label": "Ogohlantirishlar: {{count}} ta o'qilmagan",
    "channel_destination": "Qayerga: {{destination}}",
    "channel_telegram": "Telegram",
    "channel_unavailable_company_not_active": "Kompaniya faollashgach ishlaydi",
    "channel_unavailable_telegram_not_linked": "Kompaniyaning Telegram guruhi hali ulanmagan — platforma administratoriga murojaat qiling",
    "description": "Ogohlantirishlar tarixi va qaysilari Telegram guruhiga yuborilishi",
    "empty": "Ogohlantirish yo'q",
    "empty_unread": "O'qilmagan ogohlantirish yo'q",
    "example_label": "Misol",
    "eyebrow": "OGOHLANTIRISHLAR",
    "filter_all": "Hammasi",
    "filter_label": "Filtr",
    "filter_unread": "O'qilmagan",
    "history_title": "Tarix",
    "mark_all_read": "Hammasini o'qildi deb belgilash",
    "mark_all_read_done": "Hammasi o'qildi deb belgilandi",
    "mark_read": "O'qildi deb belgilash",
    "open_store": "Do'konni ochish",
    "preferences_saved": "Sozlamalar saqlandi",
    "preferences_title": "Telegram guruhiga yuborish",
    "preferences_unavailable": "Guruh ulanmaguncha sozlab bo'lmaydi",
    "preferences_unchanged": "O'zgarish yo'q — saqlash uchun biror tugmani almashtiring",
    "read_leave_list": "O'qilgan ogohlantirishlar 24 soatdan keyin ro'yxatdan chiqadi",
    "rule": "Ogohlantirish turi",
    "see_all": "Hammasini ko'rish",
    "unread": "O'qilmagan"
  },
  "api_errors": {
    "breach_check_unavailable": "Parolni hozir tekshirib bo'lmadi. Birozdan keyin qayta urinib ko'ring.",
    "captcha_required": "Davom etish uchun tekshiruvdan o'ting.",
    "company_not_active": "Kompaniya hali faollashtirilmagan. Panel super-admin kompaniyani faollashtirgandan keyin ochiladi.",
    "conflict": "Ma'lumot o'zgargan yoki allaqachon mavjud.",
    "csrf_failed": "So'rovni tekshirib bo'lmadi. Sahifani yangilang.",
    "export_failed": "Faylni tayyorlab bo'lmadi.",
    "export_not_ready": "Fayl hali tayyor emas.",
    "forbidden": "Bu bo'lim yoki amal uchun ruxsat yo'q.",
    "hour_grain_too_long": "Soatlik ma'lumot 62 kungacha bo'lgan davr uchun ko'rsatiladi. Qisqaroq davr tanlang.",
    "internal_error": "Ichki xatolik. Birozdan keyin qayta urinib ko'ring.",
    "invalid_credentials": "Login yoki parol noto'g'ri.",
    "network_error": "Serverga ulanib bo'lmadi. Internet aloqasini tekshiring.",
    "not_found": "Topilmadi yoki ruxsat yo'q.",
    "password_breached": "Bu parol sizib chiqqan parollar ro'yxatida bor. Boshqasini tanlang.",
    "password_change_required": "Davom etish uchun parolni almashtiring.",
    "password_reset_code_invalid": "Kod noto'g'ri yoki muddati o'tgan. Yangi kod so'rang.",
    "password_too_long": "Parol juda uzun.",
    "password_too_short": "Parol kamida 12 belgidan iborat bo'lishi kerak.",
    "pdf_renderer_unavailable": "PDF hozircha mavjud emas. Excel yoki CSV tanlang.",
    "rate_limited": "Juda ko'p urinish. Birozdan keyin qayta urinib ko'ring.",
    "session_expired": "Sessiya muddati tugadi. Qayta kiring.",
    "session_network_changed": "Tarmoq o'zgardi. Xavfsizlik uchun qayta kiring.",
    "telegram_bot_unavailable": "Telegram bot hali sozlanmagan. Platforma administratoriga murojaat qiling.",
    "too_many_points": "Tanlangan davr uchun ma'lumot juda ko'p. Qisqaroq davr yoki kamroq do'kon tanlang.",
    "unauthenticated": "Tizimga qayta kiring.",
    "validation_failed": "Kiritilgan ma'lumot noto'g'ri.",
    "wrong_old_password": "Joriy parol noto'g'ri."
  },
  "blocks": {
    "average_day_description": "O'rtacha kun · {{range}}",
    "hourly_flow_metric": "Soatlik oqim ko'rsatkichi",
    "hourly_flow_title": "Soatlik oqim",
    "hourly_period_too_long_text": "Masalan, oxirgi 30 kunni tanlang",
    "hourly_period_too_long_title": "Soatlik oqim 62 kungacha davr uchun",
    "hourly_series_unique": "Noyob",
    "hourly_series_visits": "Jami kirish"
  },
  "brand": {
    "product_name": "Koz.uz"
  },
  "chart": {
    "axis_not_from_zero": "O'q 0 dan boshlanmaydi",
    "other": "Boshqa"
  },
  "common": {
    "cancel": "Bekor qilish",
    "copied": "Nusxa olindi",
    "copy": "Nusxa olish",
    "delete": "O'chirish",
    "save": "Saqlash"
  },
  "comparison": {
    "best": "Eng yaxshi natija",
    "eyebrow": "FILIALLAR TAQQOSLASHI",
    "metric": "Ko'rsatkich",
    "metrics": {
      "cancelled": "Kirmay qaytganlar",
      "children": "Bolalar",
      "returning_share": "Qayta kelganlar ulushi, %",
      "unique": "Noyob mijozlar",
      "visits": "Tashriflar (jami)",
      "visits_per_hour": "Soatiga tashrif",
      "work_hours": "Ish soatlari"
    },
    "missing_range": "{{range}} uchun ma'lumot yo'q",
    "missing_short": "Solishtirish uchun ma'lumot yo'q",
    "mode_label": "Taqqoslash rejimi",
    "mode_network": "Do'kon va tarmoq o'rtachasi",
    "mode_stores": "Do'konlar",
    "network_average": "Tarmoq o'rtachasi",
    "network_index": "Tarmoq o'rtachasi 100 deb olingan",
    "partial_day": "Solishtirma davrda ma'lumot to'liq emas ({{current}} kundan {{compare}} kuni bor)",
    "partial_hour": "Solishtirma davrda ma'lumot to'liq emas ({{current}} soatdan {{compare}} soati bor)",
    "partial_store": "Solishtirma kunda ma'lumot to'liq emas ({{current}} do'kondan {{compare}} tasida bor)",
    "period_vs_period": "Joriy davr va solishtirma davr",
    "pick_more_stores": "Taqqoslash uchun kamida {{count}} ta do'kon tanlang",
    "title": "Do'konlarni taqqoslash",
    "view_indexed": "Indeks",
    "view_label": "Ko'rinish",
    "view_line": "Chiziq",
    "view_small_multiples": "Kichik grafiklar",
    "view_table": "Jadval",
    "view_weekday": "Hafta kuni",
    "weekday_title": "{{metric}} · bir kunda o'rtacha",
    "vs_range": "{{range}} ga nisbatan",
    "data_from_range": "{{range}} (ma'lumot {{date}} dan)",
    "point_no_data": "ma'lumot yo'q",
    "missing_days_legend": "{{range}} · {{count}} kun ma'lumot yo'q",
    "partial_coverage": "Ma'lumot to'liq emas: ba'zi soatlarda ma'lumot yo'q (to'liqlik: joriy davr {{current}}, solishtirma davr {{compare}})",
    "point_incomplete": "⚠ to'liq emas",
    "part_incomplete": "Ma'lumot to'liq emas: bu qismdagi ba'zi soatlarda ma'lumot yo'q yoki uzilish bo'lgan"
  },
  "dashboard": {
    "daypart_afternoon": "Kunduzi",
    "daypart_evening": "Kechqurun",
    "daypart_lunch": "Tushlik",
    "daypart_morning": "Ertalab",
    "dayparts_average_description": "O'rtacha kun bo'yicha · {{range}}",
    "dayparts_compare_label": "Solishtirish",
    "dayparts_last_week": "O'tgan hafta shu kuni",
    "dayparts_title": "Kun qismlari",
    "dayparts_yesterday": "Kecha",
    "description": "Jonli oqim va do'konlaringizning asosiy ko'rsatkichlari",
    "eyebrow": "TARMOQ KO'RINISHI · {{date}}",
    "full_ranking": "To'liq reyting",
    "insights_day": "Kechagi kun natijalari · {{date}}",
    "no_region": "Hududsiz",
    "performance_title": "Filiallar samaradorligi",
    "ranking_title": "Filiallar reytingi",
    "region_summary_unique": "{{stores}} do'kon · {{value}} noyob mijoz",
    "region_summary_visits": "{{stores}} do'kon · {{value}} tashrif",
    "store_tile_label_unique": "{{store}}: {{value}} noyob mijoz, {{change}}",
    "store_tile_label_visits": "{{store}}: {{value}} tashrif, {{change}}",
    "title": "Boshqaruv paneli"
  },
  "doors": {
    "title": "Eshiklar",
    "total_label": "Do'kon jami",
    "total_caption": "{{doors}} ta eshik orqali",
    "column_door": "Eshik",
    "column_visits": "Tashriflar",
    "column_share": "Ulush",
    "column_coverage": "Qamrov",
    "share_bar": "Eshiklar ulushi",
    "state_partial": "Qisman uzilgan",
    "state_none": "Ma'lumot yo'q",
    "partial_title": "{{total}} eshikdan {{down}} tasi ishlamadi",
    "none_title": "Hech bir eshik hisoblanmadi",
    "outage_interval": "{{door}}: {{from}}–{{to}}",
    "outage_since": "{{door}}: {{since}} dan beri",
    "note_interval": "{{from}}–{{to}} ishlamadi",
    "note_since": "{{since}} dan beri ishlamayapti",
    "note_more": "{{note}} · yana {{count}}",
    "tile_partial": "Qisman uzilgan: {{details}}",
    "tile_label_partial": "{{label}}, qisman uzilgan"
  },
  "errors": {
    "go_home": "Bosh sahifaga",
    "not_found_text": "Havola eskirgan yoki bu bo'limga ruxsat yo'q.",
    "not_found_title": "Sahifa topilmadi",
    "save_failed": "Saqlab bo'lmadi. Qayta urinib ko'ring."
  },
  "exports": {
    "delete_after_ready": "Fayl tayyor bo'lgach uni yuklab olish yoki o'chirish mumkin",
    "delete_description": "«{{name}}» ro'yxatdan va serverdan o'chiriladi. Kerak bo'lsa, hisobotni qayta yaratish mumkin.",
    "delete_failed": "Faylni o'chirib bo'lmadi. Qayta urinib ko'ring.",
    "delete_named": "«{{name}}» faylini o'chirish",
    "delete_title": "Faylni o'chirasizmi?",
    "dismiss": "Ro'yxatdan olib tashlash",
    "download": "Yuklab olish",
    "failed_hint": "Hisobotni qayta yarating",
    "failed_title": "Eksport bajarilmadi",
    "file_kept_until": "Fayl {{time}} gacha saqlanadi (yuklab olingach o'chadi)",
    "jobs_description": "Fayl yuklab olingach yoki 24 soatdan keyin o'chadi",
    "jobs_title": "Eksportlar",
    "kind_csv": "CSV (UTF-8)",
    "kind_pdf": "PDF",
    "kind_xlsx": "Excel (.xlsx)",
    "link_valid_until": "Havola {{time}} gacha amal qiladi",
    "list_failed": "Eksportlar ro'yxatini yuklab bo'lmadi",
    "no_jobs": "Hali eksport yo'q",
    "no_jobs_hint": "Hisobot yaratilsa, fayl shu yerda paydo bo'ladi",
    "ready_title": "Fayl tayyor",
    "report_control_events": "Nazorat hodisalari",
    "report_custom": "Erkin hisobot",
    "report_daily": "Kunlik hisobot",
    "report_monthly": "Oylik hisobot",
    "report_screen": "Sahifa eksporti",
    "report_weekly": "Haftalik hisobot",
    "report_yearly": "Yillik hisobot",
    "started_title": "Eksport boshlandi",
    "status_done": "Tayyor",
    "status_failed": "Xato",
    "status_queued": "Navbatda",
    "status_running": "Tayyorlanmoqda"
  },
  "filters": {
    "all_stores": "Barcha do'konlar",
    "stores": "Do'konlar"
  },
  "forgot_password": {
    "back_to_login": "Kirish sahifasiga qaytish",
    "code": "Telegram'dagi 6 xonali kod",
    "code_sent": "Ulangan bo'lsa, kod Telegram'ga yuborildi",
    "description": "Kod Telegram'ingizga yuboriladi",
    "done_text": "Parol saqlandi, boshqa sessiyalar yopildi",
    "done_title": "Parol o'zgartirildi",
    "error_code_invalid": "Kod noto'g'ri yoki muddati o'tgan. Yangi kod so'rang.",
    "go_to_login": "Kirish",
    "no_telegram_hint": "Telegram yo'qmi? Administratorga yozing",
    "request_again": "Kod kelmadimi? Qayta so'rash",
    "save_password": "Yangi parolni saqlash",
    "send_code": "Kod yuborish",
    "title": "Parolni tiklash"
  },
  "holidays": {
    "constitution_day": "Konstitutsiya kuni",
    "eid_al_adha": "Qurbon hayiti",
    "eid_al_fitr": "Ramazon hayiti",
    "independence_day": "Mustaqillik kuni",
    "navruz": "Navro'z",
    "new_year": "Yangi yil",
    "ramadan_start": "Ramazon oyi boshlanishi",
    "remembrance_day": "Xotira va qadrlash kuni",
    "teachers_day": "O'qituvchi va murabbiylar kuni",
    "womens_day": "Xotin-qizlar kuni"
  },
  "kpi": {
    "average_work_hours": "O'rtacha ish vaqti",
    "busiest_hour": "Eng gavjum soat",
    "busiest_hour_average_note_unique": "o'rtacha {{value}} noyob mijoz",
    "busiest_hour_average_note_visits": "o'rtacha {{value}} tashrif",
    "busiest_hour_compare": "{{range}}: {{hour}}",
    "busiest_hour_note_unique": "{{value}} noyob mijoz",
    "busiest_hour_note_visits": "{{value}} tashrif",
    "per_store_day": "bir do'kon, bir kun"
  },
  "languages": {
    "en": "English",
    "ru": "Русский",
    "uz": "O'zbekcha"
  },
  "live": {
    "last_hour": "Oxirgi soatda tashriflar",
    "last_hour_unique": "Oxirgi soatda noyob",
    "status_connecting": "ulanmoqda",
    "status_open": "ulangan",
    "status_reconnecting": "qayta ulanmoqda",
    "title": "Jonli hisoblagich",
    "today_entries": "Tashriflar (jonli)",
    "today_unique": "Noyob (jonli)",
    "updated_at": "Yangilandi"
  },
  "login": {
    "error_invalid": "Login yoki parol noto'g'ri",
    "error_network": "Server bilan aloqa yo'q. Internetni tekshiring.",
    "error_rate_limited": "Juda ko'p urinish. Birozdan keyin qayta urinib ko'ring.",
    "forgot_link": "Parolni unutdingizmi?",
    "login": "Login",
    "password": "Parol",
    "submit": "Kirish",
    "submitting": "Kirilmoqda…",
    "subtitle": "Kompaniyangiz hisobiga kiring.",
    "title": "Tizimga kirish"
  },
  "metric_definitions": {
    "average_work_hours": "Bitta do'kon bir kunda o'rtacha necha soat ochiq bo'lgani.",
    "busiest_hour": "Tanlangan davrda eng ko'p tashrif bo'lgan soat.",
    "cancelled": "Eshikdan kirib, 120 soniya ichida qaytib chiqqanlar (tashriflarga kirmaydi).",
    "children": "Bola deb aniqlangan kirishlar (tashriflarga kirmaydi).",
    "coverage": "Savdo vaqtining qancha qismida kameralar ishlagani. 100% — butun vaqt hisoblangan.",
    "returning": "Tashriflar ichida shu kuni qayta kelgan deb aniqlanganlar.",
    "staff": "Xodim deb aniqlangan kirishlar.",
    "unique": "Asosiy ko'rsatkich: kun davomida necha xil odam kelgani. Bir kunda qayta kelgan odam bir marta sanaladi.",
    "visits": "Do'konga barcha kirishlar soni: bir odam bir kunda ikki marta kirsa, ikki marta sanaladi. Xodimlar, bolalar va darhol qaytib chiqqanlar hisobga olinmaydi.",
    "visits_per_hour": "Do'kon ochiq bo'lgan har bir soatga o'rtacha qancha tashrif to'g'ri kelgani.",
    "work_hours": "Do'kon ochiq bo'lgan vaqt (eshik yoki ish jadvali bo'yicha)."
  },
  "metrics": {
    "cancelled": "Kirmay qaytganlar",
    "children": "Bolalar",
    "coverage": "To'liqlik",
    "returning": "Qayta kelganlar",
    "staff": "Xodim o'tishlari",
    "unique": "Noyob mijozlar",
    "visits": "Tashriflar (jami)",
    "visits_per_hour": "Soatiga tashrif",
    "work_hours": "Ish soatlari"
  },
  "months": {
    "apr": "Apr",
    "aug": "Avg",
    "dec": "Dek",
    "feb": "Fev",
    "jan": "Yan",
    "jul": "Iyl",
    "jun": "Iyn",
    "mar": "Mar",
    "may": "May",
    "nov": "Noy",
    "oct": "Okt",
    "sep": "Sen"
  },
  "nav": {
    "alerts": "Ogohlantirishlar",
    "comparison": "Taqqoslash",
    "dashboard": "Boshqaruv paneli",
    "group_account": "Hisob",
    "group_analytics": "Tahlil",
    "group_marketing": "Marketing",
    "group_operations": "Faoliyat",
    "marketing_ads": "Reklama",
    "marketing_automation": "Avtomatizatsiya",
    "marketing_campaigns": "Kampaniyalar",
    "marketing_chats": "Chatlar",
    "marketing_contacts": "Kontaktlar",
    "marketing_connections": "Ulanishlar",
    "marketing_content": "Kontent",
    "marketing_overview": "Natija",
    "marketing_report": "Hisobot",
    "marketing_sales": "Sotuv",
    "metrics": "Ko'rsatkichlar",
    "quality": "Ma'lumot sifati",
    "ranking": "Reyting",
    "reports": "Hisobotlar",
    "settings": "Sozlamalar",
    "store_control": "Do'kon nazorati",
    "stores": "Do'konlar",
    "trading_hours": "Ish vaqti",
    "trends": "Trendlar"
  },
  "password": {
    "confirm": "Yangi parolni takrorlang",
    "error_mismatch": "Parollar mos kelmadi",
    "error_password_breached": "Bu parol sizib chiqqan parollar ro'yxatida bor",
    "error_password_reused": "Yangi parol eskisidan farq qilishi kerak",
    "error_password_too_short": "Parol juda qisqa",
    "error_unknown": "Parolni o'zgartirib bo'lmadi",
    "error_wrong_old_password": "Joriy parol noto'g'ri",
    "forced_text": "Vaqtinchalik parolni o'zingiznikiga almashtiring",
    "forced_title": "Yangi parol o'rnating",
    "new": "Yangi parol",
    "old": "Joriy parol",
    "rules": "Kamida {{count}} belgi, boshqa saytlarda ishlatilmagan",
    "save": "Parolni saqlash",
    "saving": "Saqlanmoqda…"
  },
  "quality": {
    "average_coverage": "O'rtacha to'liqlik",
    "camera_offline": "oflayn",
    "camera_online": "onlayn",
    "coverage": "To'liqlik",
    "description": "Kamera holati, uzilishlar va kunlik to'liqlik",
    "eyebrow": "QURILMA SALOMATLIGI",
    "outage_kind_camera": "kamera",
    "outage_kind_pipeline": "sanoq dasturi",
    "outage_kind_system": "server",
    "outage_ongoing": "hozir ham",
    "outage_summary": "{{count}} ta uzilish · {{minutes}} daq",
    "outages": "Uzilishlar",
    "title": "Ma'lumot sifati",
    "outage_compact": "{{count}} ta · {{minutes}} daq",
    "outage_minutes": "{{minutes}} daq",
    "outage_burst": "{{count}} ta uzilish",
    "outage_details": "Batafsil",
    "outage_total_minutes": "Jami vaqt",
    "no_data": "Ma'lumot yo'q",
    "outage_count": "{{count}} ta uzilish",
    "legend_good": "≥ 99%",
    "legend_warn": "95–99%",
    "legend_bad": "< 95%",
    "legend_empty": "Ma'lumot yo'q",
    "granularity": "Davr birligi",
    "granularity_day": "Kun",
    "granularity_week": "Hafta",
    "granularity_month": "Oy",
    "outages_empty": "Uzilishlar yo'q",
    "page_summary": "{{from}}–{{to}} / {{total}}",
    "page_previous": "Oldingi sahifa",
    "page_next": "Keyingi sahifa",
    "summary_aria": "Davr bo'yicha qisqacha",
    "summary_coverage_hint": "{{count}} ta do'kon bo'yicha",
    "coverage_info": "To'liqlik — do'kon ochiq bo'lgan vaqtning necha foizida kamera va server ishlagani. Uzilish — kamera yoki server ishlamagan vaqt: o'sha daqiqalarda kirganlar sanalmaydi, shuning uchun o'sha kungi raqamlar haqiqatdagidan kam bo'lishi mumkin. Bir daqiqadan qisqa uzilishlar raqamlarga deyarli ta'sir qilmaydi.",
    "summary_significant_days": "Muhim kunlar",
    "summary_significant_hint": "{{count}} ta do'konda",
    "summary_long_outages": "Uzun uzilishlar",
    "summary_long_hint": "5 daqiqadan uzun",
    "summary_lost_time": "Yo'qotilgan vaqt",
    "summary_lost_hint": "do'kon ochiq paytida",
    "summary_cameras": "Kameralar onlayn",
    "summary_cameras_all_online": "Hammasi ishlayapti",
    "summary_cameras_offline": "Oflayn: {{names}}",
    "significant_rule": "Faqat muhim kunlar: to'liqlik 99,5% dan past yoki 5 daqiqadan uzun uzilish",
    "show_minor": "Barcha uzilishlar ({{count}} ta mayda)",
    "sort": "Tartib",
    "sort_worst": "Eng yomoni",
    "sort_date": "Sana",
    "view": "Ko'rinish",
    "view_list": "Ro'yxat",
    "view_calendar": "Kalendar",
    "group_badge_days": "{{count}} kun",
    "group_summary_worst": "eng yomoni {{date}} · {{coverage}}",
    "group_summary_lost": "jami {{duration}}",
    "group_summary_long": "{{count}} ta uzun",
    "group_summary_minor_only": "faqat mayda uzilishlar",
    "duration_hours": "{{hours}} soat {{minutes}} daq",
    "no_significant": "Bu davrda muhim uzilish bo'lmadi",
    "no_significant_hint": "Mayda uzilishli kunlar yashirilgan: {{count}}",
    "quiet_stores": "Muhim uzilishsiz: {{stores}}",
    "minor_badge": "mayda",
    "day_longest": "eng uzuni {{minutes}}",
    "calendar_aria": "To'liqlik kalendari",
    "calendar_full": "To'liq (≥ 99,5%)",
    "calendar_significant": "Muhim uzilish",
    "calendar_bad": "To'liqlik < 95%",
    "timeline_failed": "Vaqt chizig'i yuklanmadi",
    "duration_whole_hours": "{{hours}} soat"
  },
  "ranking": {
    "change": "O'zgarish, %",
    "coverage": "To'liqlik",
    "eyebrow": "REYTING",
    "from": "Boshlanishi",
    "incomplete_badge": "⚠ to'liq emas",
    "incomplete_description": "To'liqligi 95% dan past do'konlar alohida ko'rsatiladi.",
    "incomplete_title": "Ma'lumot to'liq emas",
    "index": "Indeks",
    "league_table": "Reyting jadvali",
    "metric": "Ko'rsatkich",
    "no_movers": "Bu davrda yo'q",
    "per_hour_hint": "Ish soatlari har xil do'konlarni adolatli taqqoslash uchun «Soatiga tashrif»ni tanlang",
    "period": "Davr",
    "periods": {
      "custom": "Erkin",
      "day": "Kun",
      "month": "Oy",
      "quarter": "Chorak",
      "week": "Hafta",
      "year": "Yil"
    },
    "previous": "O'tgan davr",
    "range_caption": "{{current}} · solishtirish: {{previous}}",
    "rank": "O'rin",
    "rank_change": "O'zgarish",
    "store": "Do'kon",
    "title": "Do'konlar reytingi",
    "to": "Tugashi",
    "top_drop": "Eng ko'p tushganlar",
    "top_growth": "Eng ko'p o'sganlar"
  },
  "reports": {
    "choose_month": "Oyni tanlang",
    "choose_week": "Haftani tanlang",
    "choose_year": "Yilni tanlang",
    "custom_title": "Erkin hisobot",
    "daily_range_too_long": "Ko'pi bilan {{days}} kun",
    "description": "Excel, CSV va PDF fonda tayyorlanadi",
    "eyebrow": "HISOBOTLAR",
    "field_daily": "Kun yoki davr",
    "field_monthly": "Oy",
    "field_weekly": "Hafta",
    "field_yearly": "Yil",
    "format": "Format",
    "grain": "Detallash",
    "grain_day": "Kun",
    "grain_hour": "Soat",
    "grain_month": "Oy",
    "grain_week": "Hafta",
    "kind_daily": "Kunlik",
    "kind_daily_contents": "Har do'kon: ko'rsatkichlar, ish vaqti, soatlar",
    "kind_daily_schedule": "Avtomatik: savdo kuni tugagach",
    "kind_monthly": "Oylik",
    "kind_monthly_contents": "Kunlar, hafta kunlari, reyting, o'tgan yil",
    "kind_monthly_schedule": "Avtomatik: oyning 1-kuni",
    "kind_weekly": "Haftalik",
    "kind_weekly_contents": "Kunlar, reyting, o'tgan hafta va yil",
    "kind_weekly_schedule": "Avtomatik: dushanba 09:00",
    "kind_yearly": "Yillik",
    "kind_yearly_contents": "Oylar, reyting, o'tgan yil, bayramlar",
    "kind_yearly_schedule": "Talab bo'yicha",
    "metrics": "Ko'rsatkichlar",
    "ready_title": "Tayyor hisobotlar",
    "run": "Yaratish",
    "save_template": "Shablon sifatida saqlash",
    "template_all_stores": "Barcha do'konlar",
    "template_already_editing": "Bu shablon yuqoridagi formada ochiq",
    "template_cancel_edit": "Bekor qilish",
    "template_delete_description": "«{{name}}» shabloni o'chiriladi. Undan yaratilgan fayllar o'chmaydi.",
    "template_delete_failed": "Shablonni o'chirib bo'lmadi. Qayta urinib ko'ring.",
    "template_delete_title": "Shablonni o'chirasizmi?",
    "template_edit": "Tahrirlash",
    "template_editing": "«{{name}}» shabloni tahrirlanmoqda: o'zgartiring va «O'zgarishlarni saqlash»ni bosing",
    "template_editing_badge": "Hozir tahrirlanmoqda",
    "template_more_actions": "«{{name}}» uchun boshqa amallar",
    "template_name": "Shablon nomi",
    "template_need_metric": "Kamida bitta ko'rsatkichni tanlang",
    "template_need_name": "Saqlash uchun shablon nomini kiriting",
    "template_no_permission": "Shablon saqlash uchun «Hisobotlar va ogohlantirishlar» huquqi kerak. Kompaniya administratoriga murojaat qiling.",
    "template_rename": "Nomini o'zgartirish",
    "template_rename_description": "«{{name}}» uchun yangi nom kiriting",
    "template_rename_title": "Shablon nomini o'zgartirish",
    "template_save_changes": "O'zgarishlarni saqlash",
    "template_save_failed": "Shablonni saqlab bo'lmadi. Qayta urinib ko'ring.",
    "template_store_count": "{{count}} ta do'kon",
    "templates_empty": "Shablonlar yo'q",
    "templates_empty_hint": "Yuqoridagi sozlamalarni tanlab, nom bering va «Shablon sifatida saqlash»ni bosing",
    "templates_title": "Saqlangan shablonlar",
    "title": "Hisobotlar va eksport",
    "week_number_short": "Hf",
    "week_title": "{{week}}-hafta, {{year}}"
  },
  "server_messages": {
    "alert": {
      "camera_offline": "{{store}} kamerasi ({{camera}}) {{minutes}} daqiqadan beri ishlamayapti.",
      "cancelled_spike": "{{store}}: eshikdan qaytganlar ulushi odatdagidan {{ratio}} barobar ko'p.",
      "control_summary": "{{store}}: {{hour_start}}–{{hour_end}} oralig'ida {{total}} ta ogohlantirish soatlik chegaradan oshgani uchun alohida yuborilmadi.",
      "customer_unattended": "{{store}}, {{camera}}: {{customer_count}} ta mijoz {{started_time}} dan beri {{minutes}} daqiqa xodimsiz.",
      "store_no_staff": "{{store}}: {{started_time}} dan beri {{minutes}} daqiqa do'konning hech bir kamerasida xodim ko'rinmadi.",
      "early_close": "{{store}} {{closed_at}} da yopildi (reja {{planned_at}}).",
      "flow_drop": "{{store}} bugun {{until_hour}}:00 gacha o'tgan {{weeks}} ta shu hafta kunining o'rtachasidan {{drop_pct}} past.",
      "late_open": "{{store}} bugun {{opened_at}} da ochildi (odatda {{planned_at}}).",
      "long_wait": "{{store}}, {{camera}}: mijoz {{started_time}} dan beri {{minutes}} daqiqa xizmat kutmoqda.",
      "no_data": "{{store}}: ish vaqtida {{minutes}} daqiqadan beri ma'lumot yo'q.",
      "post_empty": "{{store}}, {{camera}}: post {{started_time}} dan beri {{minutes}} daqiqa xodimsiz turibdi.",
      "record": "{{store}}: {{window_days}} kundagi eng ko'p tashrif ({{visits}}).",
      "staff_gathering": "{{store}}, {{camera}}: {{staff_count}} ta xodim {{started_time}} dan beri {{minutes}} daqiqa bir joyda to'planib turibdi.",
      "staff_phone": "{{store}}, {{camera}}: xodim {{started_time}} dan beri {{minutes}} daqiqa telefonda.",
      "target_progress": "{{store}}: oylik maqsad {{progress_pct}} bajarildi, oy tugashiga {{days_left}} kun bor."
    },
    "insight": {
      "alert": {
        "title": "Diqqat"
      },
      "leader": {
        "text": "{{store}} — {{unique}} noyob mijoz ({{visits}} tashrif).",
        "title": "Yetakchi"
      },
      "network_change": {
        "text": "{{unique}} noyob mijoz · {{change_pct}}",
        "title": "Tarmoq, o'tgan haftaga nisbatan"
      },
      "weakest": {
        "text": "{{store}}: noyob mijozlar {{change_pct}}.",
        "title": "Eng sust"
      }
    }
  },
  "section_locked": {
    "title": "«{{section}}» bo'limi siz uchun yopiq",
    "title_generic": "Bu bo'lim siz uchun yopiq",
    "reason_single_store": "Taqqoslash va reyting uchun kamida ikkita do'kon kerak bo'ladi. Sizga bitta do'kon biriktirilgan.",
    "reason_company_admin_decides": "Qaysi bo'limlarni ko'rishingizni kompaniya administratori belgilaydi. Kerak bo'lsa, unga murojaat qiling.",
    "reason_not_in_company_plan": "Bu bo'lim kompaniyangiz uchun yoqilmagan. Ulash uchun Koz.uz bilan bog'laning.",
    "back": "Boshqaruv paneliga qaytish"
  },
  "settings": {
    "api_key_created": "Yaratilgan",
    "api_key_last_used": "Oxirgi ishlatilgan",
    "api_key_name": "Nomi",
    "api_key_name_required": "Yaratish uchun kalit nomini kiriting",
    "api_key_never_used": "Hali ishlatilmagan",
    "api_key_prefix": "Kalit",
    "api_key_revoke": "{{name}} kalitini bekor qilish",
    "api_key_revoke_confirm": "Bekor qilish",
    "api_key_revoke_text": "Bu kalit bilan ishlaydigan integratsiyalar darhol to'xtaydi.",
    "api_key_revoke_title": "Kalitni bekor qilish",
    "api_key_revoked_toast": "Kalit bekor qilindi",
    "api_key_secret_text": "Kalit faqat hozir ko'rsatiladi. Uni xavfsiz joyda saqlang.",
    "api_key_secret_title": "Yangi API kaliti",
    "api_key_stores_hint": "Do'kon tanlanmasa, kalit barcha do'konlarni ko'radi",
    "api_keys_description": "Boshqa dasturlar (masalan, Power BI yoki Excel) ma'lumotlarni o'zi olishi uchun. Kalit faqat o'qiy oladi va faqat tanlangan do'konlarni ko'radi.",
    "api_keys_title": "API kalitlari",
    "appearance_description": "Faqat shu brauzerda saqlanadi",
    "appearance_title": "Til",
    "branding_color": "Kompaniya rangi",
    "branding_color_code": "Rang kodi",
    "branding_color_description": "Tugma va urg'ular rangi",
    "branding_color_error_contrast": "Rang juda och — matn o'qilmaydi. To'qroq rang tanlang.",
    "branding_color_error_format": "#RRGGBB ko'rinishida kiriting.",
    "branding_color_hint": "Juda och rangni tanlab bo'lmaydi: tugmalardagi oq yozuv o'qilishi kerak",
    "branding_color_reset": "Platforma rangiga qaytarish",
    "branding_color_save": "Rangni saqlash",
    "branding_color_saved": "Rang saqlandi",
    "branding_color_unchanged": "Rang o'zgarmagan",
    "branding_description": "Logotip panel sarlavhasida, brauzer belgisida va PDF/Excel hisobotlarida ko'rinadi.",
    "branding_logo_card_description": "Panel sarlavhasi, brauzer belgisi va hisobotlarda ko'rinadi",
    "branding_logo_card_info": "Fayl tanlagach, rasmni kvadrat yoki aylana shaklida kesasiz.",
    "branding_logo_error_file_too_large": "Fayl 2 MB dan katta.",
    "branding_logo_error_svg_not_allowed": "SVG fayllar qabul qilinmaydi — PNG yoki JPG tanlang.",
    "branding_logo_error_unsupported_type": "Faqat PNG yoki JPG fayl.",
    "branding_logo_light": "Kompaniya logotipi",
    "branding_logo_light_hint": "Yorug' va qorong'i mavzuda bir xil ishlatiladi",
    "branding_logo_none": "Logotip yo'q — platforma logotipi ko'rsatiladi",
    "branding_logo_remove": "O'chirish",
    "branding_logo_removed": "Logotip o'chirildi",
    "branding_logo_rules": "PNG yoki JPG, 2 MB gacha",
    "branding_logo_saved": "Logotip saqlandi",
    "branding_logo_title": "Logotip",
    "branding_logo_upload": "Logotip yuklash",
    "branding_read_only": "Logotip va rangni kompaniya administratori o'zgartiradi",
    "branding_shape_circle": "Shakl: aylana",
    "branding_shape_square": "Shakl: kvadrat",
    "branding_title": "Kompaniya brendi",
    "create_api_key": "Kalit yaratish",
    "create_user": "Yaratish",
    "error_login_invalid": "Login faqat kichik lotin harflari, raqamlar va . _ - belgilaridan iborat bo'lsin (kamida 3 ta)",
    "error_login_taken": "Bu login band",
    "eyebrow": "HISOB",
    "initial_password_text": "{{login}} uchun parol faqat hozir ko'rsatiladi. Birinchi kirishda almashtiriladi.",
    "initial_password_title": "Boshlang'ich parol",
    "language_label": "Til",
    "name_required": "Ismni kiriting",
    "new_api_key": "Yangi API kaliti",
    "new_password_title": "Yangi parol",
    "new_store_user": "Yangi do'kon foydalanuvchisi",
    "no_api_keys": "Kalitlar yo'q",
    "no_store_users": "Foydalanuvchilar yo'q",
    "password_changed": "Parol o'zgartirildi",
    "password_description": "Boshqa qurilmalardagi sessiyalar yopiladi",
    "password_save_needs": "Joriy parolni va yangi parolni ikki marta kiriting",
    "password_title": "Parol",
    "profile_company": "Kompaniya",
    "profile_description": "Ismingiz panelda va o'zgarishlar tarixida ko'rinadi",
    "profile_login_hint": "Loginni o'zgartirib bo'lmaydi",
    "profile_role": "Rol",
    "profile_saved": "Ism saqlandi",
    "profile_scope_hint": "Rol va do'konlarni administrator belgilaydi",
    "profile_title": "Hisob",
    "profile_unchanged": "Ism o'zgarmagan",
    "role_company_admin": "Kompaniya administratori",
    "role_store_user": "Do'kon foydalanuvchisi",
    "store_users_title": "Do'kon foydalanuvchilari",
    "tab_api_keys": "API kalitlari",
    "tab_preferences": "Ko'rinish",
    "tab_profile": "Profil",
    "tab_security": "Xavfsizlik",
    "tab_store_users": "Do'kon foydalanuvchilari",
    "telegram_bot_unavailable": "Telegram bot hali sozlanmagan — administratorga murojaat qiling",
    "telegram_connect": "Telegram'ni ulash",
    "telegram_connected": "Ulangan",
    "telegram_connected_toast": "Telegram ulandi",
    "telegram_description": "Parolni tiklash kodi shu yerga keladi",
    "telegram_disconnect": "Uzish",
    "telegram_disconnect_text": "Uzilgandan keyin parolni tiklash kodlari Telegram'ga yuborilmaydi.",
    "telegram_disconnect_title": "Telegram'ni uzasizmi?",
    "telegram_disconnected_toast": "Telegram uzildi",
    "telegram_linked_at": "{{date}} dan beri",
    "telegram_loading": "Yuklanmoqda…",
    "telegram_not_connected": "Telegram hali ulanmagan",
    "telegram_open": "Telegram'ni ochish",
    "telegram_qr_label": "Telegram botini ochish uchun QR kod",
    "telegram_step_open": "QR kodni skanerlang yoki tugmani bosing",
    "telegram_step_start": "Botda “Start” tugmasini bosing.",
    "telegram_title": "Telegram",
    "telegram_waiting": "Tasdiq kutilmoqda · {{minutes}} daqiqa",
    "user_actions": "Amallar",
    "user_actions_for": "{{login}}: amallar",
    "user_active": "faol",
    "user_block": "Bloklash",
    "user_block_text": "{{login}} panelga kira olmaydi, ochiq sessiyalari darhol yopiladi. Keyin blokdan chiqarish mumkin.",
    "user_block_title": "Foydalanuvchini bloklaysizmi?",
    "user_blocked": "bloklangan",
    "user_blocked_toast": "Foydalanuvchi bloklandi",
    "user_create_needs": "Yaratish uchun login va ismni kiriting",
    "user_edit": "Tahrirlash",
    "user_edit_description": "Login: {{login}}. Loginni o'zgartirib bo'lmaydi.",
    "user_edit_title": "Foydalanuvchini tahrirlash",
    "user_last_login": "Oxirgi kirish",
    "user_login": "Login",
    "user_login_hint": "3–64 belgi: kichik lotin harflari, raqamlar, nuqta, _ yoki -",
    "user_name": "Ism",
    "user_never_signed_in": "Hali kirmagan",
    "user_remove": "O'chirish",
    "user_remove_text": "{{login}} ro'yxatdan o'chadi va boshqa kira olmaydi. Bu loginni qayta ishlatib bo'lmaydi.",
    "user_remove_title": "Foydalanuvchini o'chirasizmi?",
    "user_removed_toast": "Foydalanuvchi o'chirildi",
    "user_reset_confirm": "Parol berish",
    "user_reset_password": "Yangi parol berish",
    "user_reset_text": "{{login}} eski paroli bilan kira olmaydi va barcha qurilmalardan chiqariladi. Yangi parol bir marta ko'rsatiladi.",
    "user_reset_title": "Yangi parol berasizmi?",
    "user_saved": "O'zgarishlar saqlandi",
    "user_status": "Holat",
    "user_stores": "Do'konlar",
    "user_stores_hint": "Do'kon tanlanmasa, barcha do'konlarga ruxsat beriladi",
    "user_unblock": "Blokdan chiqarish",
    "user_unblocked_toast": "Foydalanuvchi blokdan chiqarildi"
  },
  "shell": {
    "company_eyebrow": "{{company}} · mijoz paneli"
  },
  "store": {
    "busiest_hours_title": "Eng faol soatlar",
    "calendar_title": "Kunlar kalendari",
    "composition_not_visits": "Tashriflarga kirmaydi:",
    "composition_title": "Tashrif tarkibi",
    "description": "Tashriflar, ish vaqti va eng gavjum soatlar",
    "eyebrow": "DO'KON · {{region}}",
    "eyebrow_plain": "DO'KON",
    "hourly_table_title": "Soatlik jadval",
    "hourly_total": "Jami",
    "next_year": "Keyingi yil",
    "previous_year": "Oldingi yil",
    "switch_store": "Do'konni tanlash",
    "trading_hours_door": "Jalyuz bo'yicha o'lchangan ochilish va yopilish.",
    "trading_hours_manual": "Ish vaqti jadval bo'yicha (reja bo'yicha).",
    "trading_hours_title": "Ish vaqti",
    "weekday_heatmap_title": "Hafta kunlari va soatlar",
    "busiest_hour_mark": "eng gavjum"
  },
  "store_targets": {
    "title": "Oylik rejalar",
    "description_editor": "Har oy uchun tashriflar rejasi. Platforma administratori ham shu rejalarni ko'radi va o'zgartira oladi.",
    "description_reader": "Har oy uchun tashriflar rejasi. Rejalarni kompaniya administratori belgilaydi.",
    "list_label": "Oylik rejalar ro'yxati",
    "empty_title": "Hali reja belgilanmagan",
    "empty_editor_text": "Quyida oy va tashriflar sonini kiriting.",
    "empty_reader_text": "Rejalarni kompaniya administratori belgilaydi.",
    "load_failed": "Rejalarni yuklab bo'lmadi",
    "visits_value": "{{visits}} tashrif",
    "current_month": "Joriy oy",
    "changed_by": "O'zgartirdi: {{who}}, {{when}}",
    "changed_at": "O'zgartirildi: {{when}}",
    "platform_editor": "{{name}} (platforma administratori)",
    "progress": "Hozircha {{done}} / {{target}} · {{percent}}",
    "progress_label": "Joriy oy rejasining bajarilishi",
    "month": "Oy",
    "visits": "Tashriflar rejasi",
    "visits_hint": "0 dan 100 000 000 gacha butun son",
    "save": "Saqlash",
    "update": "Yangilash",
    "edit": "Tahrirlash",
    "edit_month": "{{month}} rejasini tahrirlash",
    "delete": "O'chirish",
    "delete_month": "{{month}} rejasini o'chirish",
    "delete_title": "Rejani o'chirish",
    "delete_text": "{{month}} uchun {{visits}} tashriflik reja o'chiriladi.",
    "saved": "Reja saqlandi",
    "updated": "Reja yangilandi",
    "deleted": "Reja o'chirildi"
  },
  "table": {
    "date": "Sana",
    "hour": "Soat",
    "store": "Do'kon"
  },
  "trading_hours": {
    "actual_vs_plan": "{{actual}} (reja {{plan}})",
    "average_close": "O'rtacha yopilish",
    "average_open": "O'rtacha ochilish",
    "chart_off_plan": "Kech ochilgan / erta yopilgan",
    "chart_plan": "Reja",
    "chart_range": "Ochildi–Yopildi",
    "closed": "Yopildi",
    "closed_today": "Bugun yopildi",
    "day_incomplete": "to'liq emas: yopilish qayd etilmagan",
    "day_no_data": "ma'lumot yo'q",
    "day_still_open": "hali yopilmagan",
    "description": "Ochilish, yopilish va jadvaldan chetlanish",
    "deviation": "Chetlanish",
    "early_by": "{{minutes}} daq erta yopildi",
    "events_description": "Faqat jalyuz kamerasi bor do'konlar",
    "events_title": "Kech ochildi / erta yopildi",
    "eyebrow": "ISH VAQTI",
    "hours": "Ishladi",
    "late_by": "{{minutes}} daq kech ochildi",
    "late_days": "Kech ochilgan kunlar",
    "late_days_value": "{{late}} / {{total}} kun",
    "no_events": "Bu davrda kechikish yo'q",
    "no_off_hours": "Bu davrda yo'q",
    "not_opened_yet": "hali ochilmagan",
    "off_hours_title": "Yopiq paytda ochilish",
    "on_time": "o'z vaqtida",
    "opened": "Ochildi",
    "opened_today": "Bugun ochildi",
    "per_schedule": "reja bo'yicha",
    "plan": "Reja",
    "planned_close": "Rejadagi yopilish",
    "planned_open": "Rejadagi ochilish",
    "source": "Manba",
    "source_door": "Jalyuz",
    "source_manual": "Jadval",
    "source_planned": "Jadval bo'yicha",
    "status": "Holat",
    "table_title": "Kunlik ish vaqti",
    "title": "Ish vaqti",
    "tooltip_closed": "Yopildi {{time}}",
    "tooltip_open_for": "Ochiq {{hours}} soat {{minutes}} daq",
    "tooltip_opened": "Ochildi {{time}}",
    "tooltip_plan": "Reja {{range}}",
    "source_schedule_fallback": "Jalyuz ma'lumoti yo'q — reja bo'yicha",
    "source_shutter_missing": "Jalyuz ma'lumoti yo'q",
    "not_measured": "reja bo'yicha, o'lchanmagan",
    "not_measured_hint": "Bu vaqtda jalyuz kamerasi ma'lumot bermadi, lekin xaridorlar kirdi: ochilish va yopilish ish jadvalidan olindi (o'lchanmagan).",
    "shutter_missing_hint": "Jalyuz kamerasi ma'lumot bermadi va ish jadvali yo'q: kun seans noma'lum holda hisoblandi.",
    "csv_not_measured_suffix": " (reja bo'yicha, o'lchanmagan)",
    "tooltip_schedule_fallback": "Jalyuz ma'lumoti yo'q — vaqtlar reja bo'yicha"
  },
  "trends": {
    "daily_title": "{{metric}}: kunlik",
    "description": "Noyob mijozlar haftalar va oylar bo'yicha o'syaptimi",
    "eyebrow": "TRENDLAR",
    "flag_recomputed": "Qayta hisoblandi",
    "flag_settings_change": "Sozlama o'zgardi",
    "metric": "Ko'rsatkich",
    "moving_average": "{{days}} kunlik o'rtacha",
    "promo_add": "Aksiya qo'shish",
    "promo_after": "Keyin",
    "promo_before": "Oldin",
    "promo_daily_average_unique": "Kunlik o'rtacha, noyob mijoz",
    "promo_daily_average_visits": "Kunlik o'rtacha, tashrif",
    "promo_delete": "{{name}} aksiyasini o'chirish",
    "promo_delete_text": "«{{name}}» aksiyasi kalendardan o'chiriladi.",
    "promo_delete_title": "Aksiyani o'chirish",
    "promo_during": "Aksiya davomida",
    "promo_empty": "Hali aksiya qo'shilmagan",
    "promo_from": "Boshlanishi",
    "promo_list": "Aksiyalar ro'yxati",
    "promo_name": "Aksiya nomi",
    "promo_not_yet": "hali tugamagan",
    "promo_title": "Aksiyalar",
    "promo_to": "Tugashi",
    "promo_vs_before": "Oldingiga nisbatan",
    "promo_window": "Davr",
    "short_history_text": "Ma'lumot {{date}} dan beri; trend 2 oydan keyin aniqroq",
    "short_history_title": "Ma'lumot hali kam",
    "title": "Trendlar",
    "yoy_title": "Oylar bo'yicha: joriy va o'tgan yil",
    "ytd_caption": "{{year}}: {{value}}",
    "ytd_note": "o'tgan yilning shu davriga nisbatan",
    "ytd_title": "{{metric}}: yil boshidan"
  },
  "user_menu": {
    "connections": "Ulanishlar",
    "language": "Til",
    "logout": "Chiqish",
    "open": "Foydalanuvchi menyusi: {{name}}",
    "theme": "Mavzu",
    "theme_dark": "Qorong'i",
    "theme_light": "Yorug'",
    "theme_system": "Avto"
  },
  "weekdays": {
    "fri": "Ju",
    "mon": "Du",
    "sat": "Sh",
    "sun": "Ya",
    "thu": "Pa",
    "tue": "Se",
    "wed": "Ch"
  },
  "table_search": {
    "stores": "Do'kon qidirish…",
    "users": "Foydalanuvchi qidirish…"
  },
  "control": {
    "compare": {
      "column_events": "Hodisalar",
      "column_minutes": "Daqiqalar",
      "column_rank": "O'rin",
      "column_region": "Hudud",
      "column_store": "Do'kon",
      "description": "Do'konlar va hududlar tarmoq o'rtachasiga nisbatan",
      "group_regions": "Hududlar",
      "group_stores": "Do'konlar",
      "grouping_label": "Guruhlash",
      "index": "Indeks",
      "index_definition": "Tarmoq o'rtachasi = 100. 100 dan past — yaxshiroq",
      "metric_label": "Ko'rsatkich",
      "metrics": {
        "per_1000_visits": "1 000 tashrifga hodisalar",
        "per_work_hour": "Ish soatiga hodisa daqiqalari"
      },
      "network_average": "Tarmoq o'rtachasi",
      "no_region": "Hududsiz",
      "pick_more": "Solishtirish uchun kamida 2 tasini tanlang",
      "ranking_title": "Barcha do'konlar reytingi",
      "regions_label": "Hududlar",
      "regions_placeholder": "Barcha hududlar",
      "search_stores": "Do'kon qidirish…",
      "state_label": "Holat"
    },
    "duration": {
      "hours_minutes": "{{hours}} s {{minutes}} daq",
      "minutes": "{{minutes}} daq",
      "minutes_seconds": "{{minutes}} daq {{seconds}} s",
      "seconds": "{{seconds}} s"
    },
    "events": {
      "all_states": "Barcha holatlar",
      "all_zones": "Barcha zonalar",
      "description": "Har bir hodisa va uning kadrlari",
      "empty": "Tanlangan filtrlar bo'yicha hodisa yo'q",
      "export_excel": "Excelga yuklash",
      "export_label": "Nazorat hodisalari · {{range}}",
      "false_positive_badge": "Xato deb belgilangan",
      "filter_states": "Holatlar",
      "filter_zone": "Zona",
      "in_progress": "Davom etmoqda",
      "list_title": "Hodisalar ro'yxati",
      "load_more": "Yana yuklash",
      "open_event": "{{state}}, {{store}}, {{time}}",
      "staff_customers": "Xodim: {{staff}} · Mijoz: {{customers}}",
      "total": "{{shown}} / {{total}}"
    },
    "eyebrow": "DO'KON NAZORATI · {{date}}",
    "minutes": "{{value}} daq",
    "open_now_badge": "Hozir ochiq: {{count}}",
    "overview": {
      "all_events": "Barcha hodisalar",
      "description": "Xodimlar intizomi va mijozlarga e'tibor",
      "empty": "Tanlangan davrda hodisa yo'q",
      "event_count": "{{formattedCount}} ta hodisa",
      "heatmap_title": "Hodisalar soat va kun bo'yicha",
      "mostly": "Ko'pi: {{state}}",
      "not_set_up": "Sozlanmagan",
      "worst_title": "Eng muammoli 5 do'kon"
    },
    "score": {
      "details": "Batafsil",
      "formula": "Baho = 100 × (1 − hodisalar daqiqalari ÷ kuzatilgan ish daqiqalari). Xato deb belgilangan hodisalar hisobga olinmaydi.",
      "grade_fair": "O'rtacha",
      "grade_good": "Yaxshi",
      "grade_poor": "Past",
      "no_data": "Ma'lumot yo'q",
      "out_of": "/ 100",
      "title": "Nazorat bahosi"
    },
    "service": {
      "by_store_title": "Do'konlar bo'yicha",
      "chart_title": "Kutish vaqti",
      "customers": "Kuzatilgan mijozlar",
      "customers_definition": "Xizmat zonalariga kirgan mijozlar soni",
      "description": "Mijoz xodimni qancha kutadi",
      "long_wait_line": "Uzoq kutish chegarasi",
      "median": "Odatdagi kutish",
      "median_definition": "Mijozlarning yarmi shundan kam kutgan (mediana)",
      "not_set_up": "Xizmat zonalari sozlanmagan",
      "p90": "Uzoq kutish",
      "p90_definition": "Mijozlarning 90% shundan kam kutgan (p90)",
      "unserved": "Xizmatsiz ketganlar",
      "unserved_definition": "Xodim yondashmasdan ketgan mijozlar ulushi",
      "view_day": "Kun",
      "view_hour": "Soat",
      "view_label": "Kesim",
      "view_weekday": "Hafta kuni"
    },
    "state_definitions": {
      "customer_unattended": "Mijozlar bor, yaqinida xodim yo'q",
      "store_no_staff": "Do'konning birorta kamerasida xodim ko'rinmadi. Barcha kameralar birga tekshiriladi; biror kamera o'chiq bo'lsa, holat ishga tushmaydi.",
      "post_empty": "Kassa yoki post zonasida xodim yo'q",
      "service_wait": "Mijoz xodim kelishini uzoq kutdi",
      "staff_gathering": "3 va undan ko'p xodim bir joyda turib qoldi",
      "staff_phone": "Xodim uzoq vaqt telefonga qaraydi"
    },
    "states": {
      "customer_unattended": "Mijoz e'tiborsiz",
      "store_no_staff": "Do'konda xodim yo'q",
      "post_empty": "Post bo'sh",
      "service_wait": "Uzoq kutish",
      "staff_gathering": "Xodimlar to'planishi",
      "staff_phone": "Xodim telefonda"
    },
    "store_block": {
      "by_zone": "Zonalar bo'yicha (bugun)",
      "details": "Batafsil",
      "none_open": "Hozir ochiq hodisa yo'q",
      "open_now": "Hozir ochiq",
      "started_ago": "{{minutes}} daq oldin",
      "title": "Nazorat",
      "today": "Bugun",
      "zone_open": "{{count}} ochiq"
    },
    "tabs": {
      "compare": "Solishtirish",
      "events": "Hodisalar",
      "overview": "Umumiy",
      "service": "Xizmat sifati"
    },
    "tabs_label": "Do'kon nazorati bo'limlari",
    "title": "Do'kon nazorati",
    "viewer": {
      "camera": "Kamera",
      "confirm_action": "Ha, xato",
      "confirm_text": "Hodisa barcha ko'rsatkichlardan chiqariladi",
      "confirm_title": "Hodisani xato deb belgilaysizmi?",
      "duration": "Davomiyligi",
      "ended": "Tugadi",
      "frame_alt": "{{state}}: kadr {{current}}, {{time}}",
      "frame_counter": "Kadr {{current}} / {{total}}",
      "frame_load_failed": "Kadr yuklanmadi",
      "frame_missing": "Kadr topilmadi",
      "frame_retry": "Qayta urinish",
      "mark_failed": "Belgilab bo'lmadi",
      "mark_false": "Bu xato",
      "marked": "Hodisa xato deb belgilandi",
      "marked_by": "{{user}} xato deb belgilagan",
      "next_frame": "Keyingi kadr",
      "no_frames": "Bu hodisa uchun kadr saqlanmagan",
      "no_media": "Kadrlarni ko'rishga ruxsatingiz yo'q",
      "people": "Odamlar",
      "previous_frame": "Oldingi kadr",
      "started": "Boshlandi",
      "store": "Do'kon",
      "zone": "Zona",
      "cameras": "Kameralar"
    },
    "time_span_open": "{{start}} – hozirgacha",
    "whole_store": "Butun do'kon"
  },
  "grouped": {
    "legend": "Ranglar",
    "period_presets": "Tezkor davr",
    "preset_last_month": "O'tgan oy",
    "preset_month": "Oy",
    "preset_week": "Hafta",
    "show_more": "Yana ko'rsatish ({{left}})",
    "show_more_groups": "Yana {{count}} ta do'kon"
  },
  "trading_hours_page": {
    "after_midnight_hint": "(+1) — yarim tundan keyin, keyingi kalendar sanasida",
    "calendar_aria": "Kunlar holati kalendari",
    "card_average_close": "O'rtacha yopilish",
    "card_average_open": "O'rtacha ochilish",
    "card_early_days": "Erta yopilgan kunlar",
    "card_late_days": "Kech ochilgan kunlar",
    "card_measured_hint": "Faqat jalyuz kamerasi bor do'konlar",
    "card_stores": "Do'konlar",
    "card_stores_hint": "{{days}} ish kuni",
    "closed_day": "ochilmadi",
    "column_average_close": "O'rt. yopilish",
    "column_average_open": "O'rt. ochilish",
    "column_closed": "Yopildi",
    "column_date": "Sana",
    "column_deviation": "Chetlanish",
    "column_early_days": "Erta yopilgan",
    "column_hours": "Ishladi",
    "column_late_days": "Kech ochilgan",
    "column_opened": "Ochildi",
    "column_openings": "Yopiq paytda ochilish",
    "column_plan": "Reja",
    "column_source": "Manba",
    "column_store": "Do'kon",
    "column_total_hours": "Jami ish vaqti",
    "column_worked_days": "Ish kunlari",
    "daily_title": "Kunlik ish vaqti",
    "days_value": "{{count}} kun",
    "deviation_value": "{{minutes}} daq",
    "download_csv": "Yuklab olish (CSV)",
    "download_csv_hint": "Davrdagi barcha kunlar, barcha do'konlar",
    "expand_store": "{{store}}: kunlarni ko'rsatish",
    "filter_all": "Barchasi",
    "filter_label": "Qaysilarini ko'rsatish",
    "filter_longer": "Uzunroq",
    "filter_minutes_label": "Necha daqiqadan uzun",
    "filter_minutes_option": "{{minutes}} daq dan uzun",
    "filter_night": "Faqat tunda",
    "kind_cleaning": "Tozalash",
    "kind_night": "Tungi ochilish",
    "latest": "oxirgisi {{date}}",
    "minutes": "{{minutes}} daq",
    "next_page": "Keyingi",
    "no_rows": "Bu davrda ma'lumot yo'q",
    "openings_info": "Do'kon yopiq paytda jalyuz qisqa vaqtga (2 soatdan kam) ochilgan: odatda tozalash yoki tovar qabul qilish. Tunda (00:00–06:00) ochilish alohida belgilanadi. Faqat jalyuz kamerasi bor do'konlar.",
    "openings_list": "Do'konlar bo'yicha ochilishlar",
    "openings_none": "Bu davrda do'kon yopiq paytda ochilmagan",
    "openings_none_filtered": "Tanlangan shartga mos ochilish yo'q",
    "openings_summary": "{{stores}} do'kon · {{openings}} ta ochilish · eng uzuni {{longest}}",
    "openings_title": "Yopiq paytda ochilish",
    "page_status": "{{from}}–{{to}} / {{total}} do'kon",
    "per_schedule": "reja bo'yicha",
    "previous_page": "Oldingi",
    "status_closed": "Ochilmadi",
    "status_late": "Kech ochildi / erta yopildi",
    "status_no_data": "Ma'lumot yo'q",
    "status_on_time": "O'z vaqtida",
    "status_per_schedule": "Reja bo'yicha (jalyuz kamerasi yo'q)",
    "summary_aria": "Davr bo'yicha qisqacha",
    "times": "{{count}} marta",
    "total_hours_value": "{{hours}} soat",
    "view_calendar": "Kalendar",
    "view_label": "Ko'rinish",
    "view_table": "Do'konlar bo'yicha"
  },
  "marketing": {
    "billz": {
      "title": "Billz",
      "token": "Billz maxfiy tokeni",
      "connect": "Ulash",
      "stores_hint": "Har bir do'konga Billz'dagi do'konini tanlang. Sotuv kunlik yig'indi sifatida o'qiladi.",
      "no_shop": "Ulanmagan",
      "save": "Saqlash va yuklash",
      "disconnect": "Uzish",
      "disconnect_title": "Billz uzilsinmi?",
      "disconnect_text": "Yangi sotuv o'qilmaydi. O'qilgan sotuv qoladi.",
      "status_on": "Ulangan",
      "status_stores": "Do'kon tanlang",
      "status_error": "Xato",
      "checking": "Tekshirilmoqda…",
      "accepted": "Token qabul qilindi. Billz'da {{count}} ta do'kon topildi. Endi do'konlarni moslang.",
      "no_shops": "Token qabul qilindi, lekin Billz do'konlar ro'yxatini bermadi. Tokenning ruxsatlarini tekshiring.",
      "refused": "Billz bu tokenni qabul qilmadi. Tokenni tekshirib, qayta kiriting.",
      "running": "Qabul qilindi, hisobotlar yuklanmoqda: {{percent}}%",
      "running_hint": "Oxirgi {{loaded}} kun tayyor, jami {{total}} kun yuklanadi. Oynani yopsangiz ham davom etadi, hisobotlar yuklangani sari to'lib boradi.",
      "running_start": "Oxirgi {{total}} kunlik sotuv o'qilmoqda. Oynani yopsangiz ham davom etadi.",
      "failed": "Yuklash {{percent}}% da to'xtadi",
      "failed_hint": "Billz javob bermadi. Keyingi soatda o'zi shu joydan davom etadi.",
      "done": "{{total}} kunlik sotuv yuklandi",
      "save_first": "Do'konni tanlang",
      "close": "Yopish"
    },
    "period_label": "Davr",
    "money": "{{value}} so'm",
    "pager": "{{first}}–{{last}} / {{total}}",
    "pager_previous": "Oldingi sahifa",
    "pager_next": "Keyingi sahifa",
    "errors": {
      "not_available": "Bu imkoniyat hali tayyor emas.",
      "not_linked": "Bu Instagram akkaunt xabarlar xizmatiga ulanmagan.",
      "bot_unavailable": "Xabarlar xizmatiga ulanib bo'lmadi. Birozdan keyin qayta urinib ko'ring.",
      "bot_error": "Xabarlar xizmati so'rovni bajarmadi. Birozdan keyin qayta urinib ko'ring.",
      "center_unavailable": "Tashrif ma'lumotini olib bo'lmadi. Birozdan keyin qayta urinib ko'ring.",
      "reply_window_closed": "Javob oynasi yopilgan. Mijoz yana yozsa, javob bera olasiz.",
      "instagram_send_failed": "Instagram xabarni qabul qilmadi. Qayta urinib ko'ring.",
      "stop_failed": "Avtomatizatsiyalarni to'xtatib bo'lmadi, shuning uchun akkaunt uzilmadi. Birozdan keyin qayta urinib ko'ring.",
      "erase_failed": "Ma'lumotlarni o'chirib bo'lmadi, shuning uchun akkaunt uzilmadi. Birozdan keyin qayta urinib ko'ring.",
      "shared_automations": "Bu akkauntning ayrim avtomatizatsiyalari shu egasining boshqa akkauntida ham javob beradi. Ularni avtomatizatsiya bo'limida o'chirib, qayta urinib ko'ring.",
      "shared_data": "Bu akkaunt ma'lumotlarining bir qismi shu egasining boshqa akkaunti bilan umumiy. Ularni o'chirish uchun support@topkey.uz manziliga yozing.",
      "connected_elsewhere": "Bu akkaunt boshqa kompaniyaga ham ulangan. Ma'lumotlarini o'chirish uchun support@topkey.uz manziliga yozing."
    },
    "answer": {
      "estimate": "Taxminiy: boshqa do'kon bilan solishtirilmagan, mavsum ham ta'sir qilishi mumkin.",
      "question": "Reklama foyda keltirdimi?",
      "no_spend": "Xarajat kiritilmagan, shuning uchun foyda to'liq hisoblanmagan.",
      "profit": {
        "title": "Ha, {{profit}} foyda",
        "detail": "Qo'shimcha sotuv {{sales}}, xarajat {{spend}}.",
        "action": "Kampaniyalar"
      },
      "loss": {
        "title": "Yo'q, {{profit}} zarar",
        "detail": "Qo'shimcha sotuv {{sales}}, xarajat {{spend}}.",
        "action": "Kampaniyalar"
      },
      "need_margin": {
        "title": "Qo'shimcha sotuv: {{sales}}",
        "detail": "Foydani ko'rish uchun foyda foizini kiriting.",
        "action": "Foyda foizini kiritish"
      },
      "need_sales": {
        "title": "Tashrif oshdi: +{{visits}}",
        "detail": "Foydani ko'rish uchun kampaniya kunlari sotuvini yuklang.",
        "action": "Sotuvni yuklash"
      },
      "unclear": {
        "title": "Hali aniq emas",
        "detail": "Qo'shimcha tashrif {{low}} dan {{high}} gacha: o'sish hali tasdiqlanmadi.",
        "action": "Kampaniyalar"
      },
      "down": {
        "title": "Yo'q, tashrif oshmadi",
        "detail": "Reklamadagi do'konlar nazorat do'konidan orqada qoldi.",
        "action": "Kampaniyalar"
      },
      "waiting": {
        "title": "Natija kutilmoqda",
        "detail": "Kampaniya boshlangach, oldingi kunlar bilan solishtirib hisoblanadi.",
        "action": "Kampaniyalar"
      },
      "no_control": {
        "title": "Hisoblab bo'lmaydi",
        "detail": "Kampaniyada nazorat do'koni yo'q. Yangi kampaniyada uni tanlang.",
        "action": "Kampaniya qo'shish"
      },
      "one_store": {
        "title": "Natijaga hali ma'lumot yetmayapti",
        "detail": "Kampaniyadan oldingi kamida 2 haftalik tashrif kerak. Tashrif va sotuv pastda.",
        "action": "Kampaniyalar"
      },
      "period_empty": {
        "title": "Bu davrda kampaniya yo'q",
        "detail": "Boshqa davrni tanlang yoki yangi kampaniya qo'shing.",
        "action": "Kampaniyalar"
      }
    },
    "overview": {
      "title": "Natija",
      "full_report": "Barcha ko'rsatkichlar",
      "spend": "Reklama xarajati",
      "extra_visits": "Qo'shimcha tashrif",
      "range": "Oraliq: {{low}} … {{high}}",
      "visit_cost": "Bir tashrif narxi",
      "buyer_cost": "Bir xaridor narxi",
      "chart_title": "Kunlik dinamika",
      "funnel_title": "Ko'rishdan xaridgacha",
      "measured_spend": "Natijasi o'lchangani: {{value}}",
      "paid_hint": "Sana va xarajatni kiritsangiz, sarflangan pul qaytganini hisoblaymiz. Bu ixtiyoriy.",
      "paid_action": "Reklama qo'shish"
    },
    "verdict": {
      "up": "Tashrif oshdi",
      "down": "Tashrif kamaydi",
      "unclear": "Aniqlab bo'lmadi"
    },
    "leak": {
      "content": {
        "title": "Kontent yoki taklif odamni qiziqtirmayapti",
        "action": "Taklifni va kontentni almashtirib ko'ring."
      },
      "reply": {
        "title": "Qiziqish bor, lekin odam do'konga kelmayapti",
        "action": "Tezroq javob bering, manzil va promo-kod qo'shing."
      },
      "store": {
        "title": "Tashrif oshdi, sotuv oshmadi",
        "action": "Muammo do'kon ichida: sotuvchi, narx yoki assortimentni tekshiring."
      },
      "margin": {
        "title": "Sotuv oshdi, foyda oshmadi",
        "action": "Chegirma va reklama budjetini qayta ko'rib chiqing."
      },
      "none": {
        "title": "Reklama foyda keltiryapti",
        "action": "Shu yo'nalishni davom ettiring va qaytib kelishni kuzating."
      },
      "not_enough_data": {
        "title": "Xulosa uchun ma'lumot yetarli emas",
        "action": "Yuqoridagi qadamlarni tugating, xulosa shundan keyin chiqadi."
      }
    },
    "factor": {
      "conversion": "Xaridga aylanish",
      "average_check": "O'rtacha chek",
      "returning": "Qaytgan mijozlar",
      "local_reach": "Mahalliy qamrov",
      "reply": "Javob tezligi",
      "quiet_hours": "Bo'sh soatlar"
    },
    "campaigns": {
      "title": "Kampaniyalar",
      "new_title": "Yangi kampaniya",
      "edit_title": "Kampaniyani tahrirlash",
      "edit": "Tahrirlash",
      "edit_named": "Tahrirlash: {{name}}",
      "name": "Nomi",
      "offer": "Taklif",
      "stores": "Reklama qilinadigan do'konlar",
      "control_stores": "Nazorat do'koni",
      "control_hint": "Reklama qilinmaydigan o'xshash do'kon. Farq reklama natijasini ko'rsatadi.",
      "single_store_hint": "Foydani o'lchash uchun solishtiradigan ikkinchi do'kon kerak.",
      "choose_stores": "Do'kon tanlang",
      "overlap_error": "Bitta do'kon ikkala ro'yxatda bo'la olmaydi.",
      "from": "Boshlanishi",
      "to": "Tugashi",
      "dates_error": "Tugash sanasi boshlanishdan oldin bo'lmasin.",
      "radius": "Reklama radiusi, km",
      "save": "Kampaniyani saqlash",
      "created": "Kampaniya saqlandi",
      "status": "Holati",
      "period": "Davr",
      "result": "Natija",
      "result_no_control": "Nazorat do'koni yo'q",
      "result_not_started": "Hali boshlanmagan",
      "result_waiting": "Natija kutilmoqda",
      "empty": "Hali kampaniya yo'q",
      "empty_hint": "Foyda kampaniya orqali hisoblanadi.",
      "add": "Kampaniya qo'shish",
      "delete": "O'chirish",
      "delete_title": "Kampaniyani o'chirasizmi?",
      "delete_description": "«{{name}}» kampaniyasi ro'yxatdan o'chiriladi.",
      "details": "Kampaniya",
      "spend": "Reklama xarajati, so'm"
    },
    "campaign_status": {
      "planned": "Rejada",
      "running": "Ishlayapti",
      "finished": "Tugagan"
    },
    "content": {
      "title": "Kontent",
      "empty_title": "Instagram hali ulanmagan",
      "syncing_title": "Instagram ulangan, postlar hali kelmadi",
      "syncing_hint": "Birinchi yuklash bir necha daqiqa oladi.",
      "refresh": "Yangilash",
      "caption": "Kontent",
      "kind": "Turi",
      "published": "Sana",
      "views": "Ko'rishlar",
      "reach": "Qamrov",
      "saves": "Saqlashlar",
      "comments": "Izohlar",
      "direct_messages": "Xabarlar",
      "view": "Ko'rinish",
      "view_grid": "Rasmlar",
      "view_table": "Jadval"
    },
    "content_kind": {
      "reel": "Reels",
      "post": "Post",
      "story": "Story"
    },
    "ads": {
      "title": "Reklama",
      "not_ready_title": "Reklama kabineti hali mavjud emas",
      "not_ready_hint": "Hozircha reklama xarajatini kampaniyaga yozing.",
      "to_campaigns": "Kampaniyalarga o'tish",
      "name": "Kampaniya",
      "status": "Holati",
      "spend": "Xarajat",
      "reach": "Qamrov",
      "clicks": "Bosishlar",
      "local_reach": "Mahalliy qamrov"
    },
    "ad_status": {
      "active": "Faol",
      "paused": "To'xtatilgan",
      "ended": "Tugagan"
    },
    "automation": {
      "title": "Avtomatizatsiya",
      "empty_title": "Bu akkaunt avtomatizatsiyaga ulanmagan",
      "name": "Avtomatizatsiya",
      "keywords": "Kalit so'zlar",
      "comments": "Izohlar",
      "direct_messages": "Xabar yuborildi",
      "saved": "Saqlandi",
      "failed": "Xato",
      "match": "Moslik",
      "match_contains": "Ichida bor",
      "match_exact": "Aynan",
      "match_starts_with": "Boshlanadi",
      "posts": "Postlar",
      "all_posts": "Barcha postlar",
      "message": "Xabar matni",
      "followup": "Keyingi xabar",
      "delete": "O'chirish",
      "save": "Saqlash",
      "delete_title": "Avtomatizatsiyani o'chirasizmi?",
      "empty": "Hali avtomatizatsiya yo'q",
      "new_title": "Yangi avtomatizatsiya",
      "triggers": "Qachon ishlaydi",
      "trigger_comment": "Izoh",
      "trigger_dm": "Xabar",
      "trigger_story_reply": "Story javobi",
      "trigger_story_mention": "Story'da belgilash",
      "edit": "Tahrirlash",
      "actions": "Amallar: {{name}}",
      "not_found": "Avtomatizatsiya topilmadi",
      "wizard": {
        "exit": "Chiqish",
        "back": "Orqaga",
        "next": "Keyingi",
        "create": "Yaratish",
        "preview": "Ko'rinishi",
        "step_of": "{{current}}-qadam, jami {{total}}",
        "step_trigger": "Qachon ishlaydi",
        "step_message": "Xabar",
        "step_extras": "Qo'shimcha",
        "leave_title": "Saqlamasdan chiqasizmi?",
        "leave_text": "O'zgarishlar yo'qoladi.",
        "leave_confirm": "Chiqish",
        "templates_title": "Nima qilsin?",
        "templates": {
          "comment_link": {
            "title": "Izohga xabar va havola",
            "description": "Izoh yozganga xabar boradi, obunachi havolani oladi.",
            "keywords": "link|havola",
            "message": "Salom! Akkauntimizga obuna bo'ling, keyin pastdagi tugmani bosing, havolani yuboramiz.",
            "button": "Obuna bo'ldim",
            "followup": "Rahmat! Mana havola: https://",
            "replies": "Xabar yubordik!|Direct'ni tekshiring|Javobni xabarda yozdik"
          },
          "price": {
            "title": "Narx so'roviga javob",
            "description": "Narxni so'rashsa, javob darhol boradi.",
            "keywords": "narx|necha pul|qancha",
            "message": "Salom! Qaysi mahsulot qiziqtirdi? Rasmini yuboring, narxini aytamiz.",
            "replies": "Javobni xabarda yozdik|Direct'ni tekshiring"
          },
          "story": {
            "title": "Story javobi",
            "description": "Story'ga javob yozganlarga xabar boradi.",
            "keywords": "xohlayman|qiziq",
            "message": "Javobingiz uchun rahmat! Savolingiz bo'lsa, shu yerga yozing."
          },
          "blank": {
            "title": "Bo'sh",
            "description": "Bo'sh formadan boshlash."
          }
        },
        "trigger_text_comment": "Post yoki reels ostiga izoh yozilsa",
        "trigger_text_dm": "Direct'ga xabar yozilsa",
        "trigger_text_story_reply": "Story'ga javob yozilsa",
        "trigger_text_story_mention": "Story'da sizni belgilashsa, kalit so'z kerak emas",
        "posts_specific": "Tanlangan postlar",
        "posts_empty": "Bu akkauntda post topilmadi",
        "posts_selected": "Tanlandi: {{count}}",
        "post_number": "{{number}}-post",
        "keywords_hint": "Har bir so'zdan keyin Enter bosing.",
        "keywords_placeholder": "narx",
        "message_placeholder": "Salom! Siz so'ragan ma'lumot...",
        "button_title": "Tugma va keyingi xabar",
        "button_text": "Tugma bosilganda obuna tekshiriladi, keyin keyingi xabar boradi.",
        "button_text_mixed": "Tugma bosilganda obuna tekshiriladi, keyin keyingi xabar boradi. Faqat izohga javobda ishlaydi.",
        "button_label": "Tugma matni",
        "button_default": "Obuna bo'ldim",
        "followup_placeholder": "Rahmat! Mana...",
        "replies_title": "Izohga ochiq javoblar",
        "replies_text": "Har bir izohga tasodifiy bittasi yoziladi.",
        "replies_default": "Xabar yubordik!|Direct'ni tekshiring|Javobni xabarda yozdik",
        "reply_number": "{{number}}-javob",
        "reply_remove": "{{number}}-javobni o'chirish",
        "reply_add": "Javob qo'shish",
        "reminder_title": "Obuna eslatmasi o'zingizniki",
        "reminder_text": "Obuna bo'lmasdan tugmani bosganga yuboriladi. O'chiq bo'lsa, standart matn boradi.",
        "reminder_label": "Eslatma matni",
        "reminder_default": "Avval akkauntimizga obuna bo'ling, keyin tugmani qayta bosing.",
        "active_title": "Darhol yoqish",
        "active_text": "O'chiq bo'lsa saqlanadi, lekin siz yoqmaguningizcha javob bermaydi.",
        "error_need_trigger": "Kamida bittasini tanlang",
        "error_need_post": "Kamida bitta post tanlang",
        "error_need_keyword": "Kalit so'z qo'shing",
        "error_need_message": "Xabar matnini yozing",
        "error_too_long": "Matn juda uzun",
        "error_need_link": "https:// dan keyin havolani yozing",
        "error_need_button": "Tugma matnini yozing",
        "error_need_followup": "Keyingi xabarni yozing",
        "error_need_reply": "Kamida bitta javob yozing",
        "error_need_reminder": "Eslatma matnini yozing",
        "preview_tab_message": "Xabar",
        "preview_tab_comment": "Izoh",
        "preview_account": "akkauntingiz",
        "preview_user": "mijoz",
        "preview_keyword": "kalit so'z",
        "preview_comment_note": "Izohingizga javob: {{keyword}}",
        "preview_story_reply": "Story'ga javob",
        "preview_story_mention": "Story'da sizni belgiladi",
        "preview_input": "Xabar...",
        "preview_comments": "Izohlar",
        "preview_random": "{{count}} tadan biri, tasodifiy"
      }
    },
    "sales": {
      "title": "Sotuv",
      "format_hint": "Har qatorda: sana, do'kon nomi, sotuv summasi, cheklar soni. Namunani oching, summalarni to'ldiring va yuklang.",
      "file_hint": "Faqat CSV fayl",
      "file_errors": "Faylda {{count}} ta xato, hech narsa yuklanmadi:",
      "more_errors": "Yana {{count}} ta xato.",
      "store_names": "Paneldagi nomlar: {{names}}",
      "empty_file": "Faylda sotuv qatorlari yo'q",
      "unreadable_file": "Faylni o'qib bo'lmadi. CSV ekanini tekshiring.",
      "imported": "{{count}} ta qator yuklandi",
      "imported_dates": "Sanalar: {{from}} – {{to}}",
      "error": {
        "columns": "{{line}}-qator: 4 ta ustun bo'lishi kerak",
        "date": "{{line}}-qator: sana noto'g'ri ({{value}}). Namuna: 2026-11-04",
        "store": "{{line}}-qator: do'kon topilmadi ({{value}})",
        "revenue": "{{line}}-qator: sotuv summasi yozilmagan yoki noto'g'ri ({{value}})",
        "receipts": "{{line}}-qator: cheklar soni yozilmagan yoki noto'g'ri ({{value}})",
        "duplicate": "{{line}}-qator: bu kun va do'kon ikki marta yozilgan ({{value}})"
      },
      "margin": "Foyda foizi, %",
      "margin_hint": "100 so'mlik sotuvdan qancha foyda qoladi.",
      "save": "Saqlash",
      "margin_saved": "Foyda foizi saqlandi",
      "date": "Sana",
      "store": "Do'kon",
      "revenue": "Sotuv",
      "receipts": "Cheklar",
      "empty": "Bu davrda sotuv ma'lumoti yo'q",
      "empty_hint": "Kunlik sotuv va cheklar faylini yuklang.",
      "upload": "Yuklash",
      "upload_title": "Sotuv faylini yuklash",
      "sample": "Namuna faylni yuklab olish",
      "total": "Jami sotuv",
      "average_check": "O'rtacha chek",
      "all_stores": "Barcha do'konlar",
      "margin_value": "Foyda: {{value}}%",
      "margin_empty": "Foyda foizini kiriting"
    },
    "connections": {
      "title": "Ulanishlar",
      "connected": "Ulangan",
      "not_connected": "Ulanmagan",
      "disconnect": "Uzish",
      "disconnect_title": "Uzib, avtomatizatsiyalarni to'xtatasizmi?",
      "disconnect_instagram_description": "{{name}} va uning postlari paneldan o'chadi, barcha avtomatizatsiyalari javob berishni to'xtatadi. Yozishmalar tarixi saqlanadi. Qayta ulanganda ular o'zi yoqilmaydi: ularni o'zingiz yoqasiz.",
      "disconnect_stop": "Uzish va to'xtatish",
      "reconnect_needed": "Qayta ulash kerak",
      "reconnect": "Qayta ulash",
      "erase": "Ma'lumotlarni o'chirish",
      "erase_title": "Akkauntning barcha ma'lumotlari o'chirilsinmi?",
      "erase_description": "{{name}} akkauntining barcha xabarlari, jurnallari, izohlari, avtomatizatsiyalari va tokenlari xabarlar xizmatidan, ulanishi va postlari esa shu paneldan o'chiriladi. Buni ortga qaytarib bo'lmaydi.",
      "erase_confirm": "Hammasini o'chirish",
      "erased": "Akkaunt ma'lumotlari o'chirildi",
      "automation_not_linked": "Avtomatizatsiya ulanmagan",
      "instagram": {
        "title": "Instagram"
      },
      "sales": {},
      "connect": "Ulash",
      "sales_label": "Sotuv",
      "open": "Ochish",
      "return": {
        "connected": "Instagram ulandi",
        "cancelled": "Ulanish bekor qilindi",
        "expired": "Vaqt tugadi, qayta urinib ko'ring",
        "failed": "Ulanib bo'lmadi"
      },
      "sales_hint": "Billz yoki kunlik fayl. Foyda foizi pullik reklama foydasini hisoblaydi.",
      "upload_file": "Faylni yuklash"
    },
    "accounts": {
      "switch": "Instagram akkaunt: {{name}}",
      "none": "Akkaunt yo'q",
      "connect_new": "Yangi akkaunt ulash",
      "reconnect": "{{name}} ni qayta ulash"
    },
    "period_days": "{{count}} kun",
    "seconds": "{{count}} soniya",
    "new": "Yangi",
    "all": "Hammasi",
    "metric": {
      "spend": "Xarajat",
      "visits": "Tashrif",
      "sales": "Sotuv"
    },
    "funnel": {
      "views": "Ko'rishlar",
      "direct_messages": "Xabarlar",
      "extra_visits": "Qo'shimcha tashrif",
      "buyers": "Xaridorlar"
    },
    "money_million": "{{value}} mln so'm",
    "chats": {
      "title": "Chatlar",
      "search": "Qidirish",
      "kind_conversations": "Suhbatlar",
      "kind_all": "Hammasi",
      "empty": "Hali suhbat yo'q",
      "empty_all": "Hali hech kim izoh yoki xabar yozmagan",
      "empty_action": "Avtomatizatsiyani yoqish",
      "not_found": "Hech kim topilmadi",
      "clear_search": "Qidiruvni tozalash",
      "load_more": "Yana ko'rsatish",
      "choose": "Suhbatni tanlang",
      "back": "Orqaga",
      "unknown_person": "Instagram foydalanuvchisi",
      "no_messages": "Hali xabar yo'q",
      "placeholder": "Javob yozing",
      "send": "Yuborish",
      "window_closed_title": "Hozir javob berib bo'lmaydi",
      "window_closed_hint": "Instagram oxirgi xabardan keyin 24 soat ruxsat beradi. Mijoz yana yozsa, javob bera olasiz.",
      "comment_only_title": "Bu odam faqat izoh yozgan",
      "comment_only_hint": "Instagram birinchi bo'lib yozishga ruxsat bermaydi. U xabar yozsa, javob bera olasiz.",
      "open_instagram": "Instagramda ochish",
      "delete_data": "Bu odamning ma'lumotlarini o'chirish",
      "delete_data_title": "Bu odamning ma'lumotlari o'chirilsinmi?",
      "delete_data_description": "Uning shu akkauntdagi xabarlari, izohlari, jurnallari va teglari o'chiriladi. Buni ortga qaytarib bo'lmaydi. Yana yozsa yoki izoh qoldirsa, yangi xabarlari yoziladi.",
      "delete_data_confirm": "O'chirish",
      "delete_data_done": "Bu odamning ma'lumotlari o'chirildi",
      "comment": "Izoh",
      "tags": "Teglar",
      "not_linked": "Instagram hali ulanmagan",
      "service_off_title": "Xabarlar xizmati hali yoqilmagan",
      "service_off_hint": "Instagram ulangan. Xizmat yoqilgach, suhbatlar shu yerda ko'rinadi."
    },
    "contacts": {
      "title": "Kontaktlar",
      "name": "Kontakt",
      "total": "Jami: {{count}}",
      "comments": "Izohlar",
      "messages": "Xabarlar",
      "last": "Oxirgi faollik",
      "reply": "Javob",
      "tags": "Teglar",
      "empty": "Hali kontakt yo'q",
      "can_reply": "Javob berish mumkin"
    },
    "report": {
      "title": "Hisobot",
      "metric": "Ko'rsatkich",
      "value": "Qiymat",
      "next": "Holat",
      "ready": "Tayyor",
      "cities": "Do'kon shaharlari",
      "metric_profit": "Qo'shimcha foyda",
      "metric_cost_per_customer": "Bir xaridor narxi",
      "metric_conversion": "Xaridga aylanish",
      "metric_returning": "Qaytgan mijozlar",
      "metric_local_reach": "Mahalliy qamrov",
      "metric_offer": "Eng yaxshi taklif",
      "metric_reply_speed": "Javob tezligi",
      "metric_timing": "Bo'sh soatlar",
      "step_campaign": "Pullik reklama bo'lsa hisoblanadi",
      "step_control": "Nazorat do'konini tanlang",
      "step_one_store": "Kamida 2 hafta tashrif kerak",
      "step_sales": "Sotuvni yuklang",
      "step_margin": "Foyda foizini kiriting",
      "step_unconfirmed": "O'sish tasdiqlanmagan",
      "step_cities": "Shaharni tanlang",
      "step_instagram": "Instagramni ulang",
      "step_automation": "Avtomatizatsiya yoqilsa chiqadi",
      "step_visits": "Tashrif ma'lumoti yo'q"
    },
    "organic": {
      "question": "Kontent davrida do'konda nima o'zgardi?",
      "no_history": {
        "title": "Solishtirishga hali tarix yetmaydi",
        "detail": "Oldingi kamida 3 haftalik tashrif yoki sotuv kerak. Billz ulansa, 90 kunlik sotuv o'zi yuklanadi."
      },
      "visits_up": "Tashrif oshdi: {{value}}",
      "visits_down": "Tashrif kamaydi: {{value}}",
      "visits_unclear": "Tashrifda aniq o'zgarish yo'q",
      "sales_up": "Tushum oshdi: {{value}}",
      "sales_down": "Tushum kamaydi: {{value}}",
      "sales_unclear": "Tushumda aniq o'zgarish yo'q",
      "detail": "Oldingi 4 hafta bilan solishtirildi. Shu davrda {{posts}} ta post, {{views}} ko'rish.",
      "detail_no_posts": "Oldingi 4 hafta bilan solishtirildi. Shu davrda Instagram posti ko'rinmaydi.",
      "estimate": "Taxminiy: bu vaqt bo'yicha solishtirish. Mavsum yoki bayram ham ta'sir qilishi mumkin.",
      "with_campaign_note": "Bu davrda pullik reklama ham bo'lgan, o'zgarish faqat kontentdan emas.",
      "against_before": "Oldingi 4 haftaga nisbatan {{value}}",
      "visits_total": "Tashriflar",
      "sales_total": "Tushum",
      "shares": "Ulashishlar",
      "posts_title": "Har bir postdan keyingi 3 kun",
      "visits_after": "Tashrif",
      "sales_after": "Tushum",
      "note": "Izoh",
      "with_post": "Boshqa post bilan bir kunlarda",
      "with_campaign": "Reklama bilan bir kunlarda",
      "no_history_short": "Tarix yetmaydi",
      "no_clear_change": "Aniq emas ({{value}})",
      "range": "Ehtimoliy oraliq: {{low}} … {{high}}",
      "question_no_posts": "Oldingi 4 haftaga nisbatan nima o'zgardi?"
    },
    "chain": {
      "seen": "Ko'rdi",
      "came": "Kirdi",
      "bought": "Xarid qildi",
      "paid": "Tushum",
      "seen_note": "Davrdagi postlar ko'rishlari",
      "seen_empty": "Reels va postlar ko'rishlari",
      "came_note": "Kamera sanagan",
      "came_empty": "Kamera ma'lumoti yo'q",
      "sales_empty": "Billz yoki fayl orqali",
      "connect_instagram": "Instagramni ulang",
      "connect_sales": "Sotuvni ulang",
      "bought_note": "Kirganlarning {{value}}",
      "paid_note": "O'rtacha chek {{value}}",
      "days": "Kamera va sotuv birga bor {{count}} kun bo'yicha. Bugungi kun kirmaydi.",
      "days_one_source": "{{count}} kun bo'yicha. Bugungi kun kirmaydi.",
      "leak_title": "Eng katta yo'qotish do'kon ichida: kirganlarning {{lost}}% xaridsiz chiqadi.",
      "finding_none": "Eng yaxshi kunlarni qolganidan ajratadigan aniq farq hozircha topilmadi.",
      "finding_sellers_together": "Farq sotuvchilarda: {{sellers}} birga ishlagan {{with_days}} kunda kirganlarning {{with_percent}}% xarid qildi, qolgan {{other_days}} kunda {{other_percent}}%.",
      "finding_sellers_one": "Farq sotuvchida: {{sellers}} ishlagan {{with_days}} kunda kirganlarning {{with_percent}}% xarid qildi, qolgan {{other_days}} kunda {{other_percent}}%.",
      "finding_post": "Farq kontentda: post chiqqan va keyingi 2 kunda kirganlarning {{with_percent}}% xarid qildi ({{with_days}} kun), qolgan {{other_days}} kunda {{other_percent}}%.",
      "finding_campaign": "Farq reklamada: reklama kunlarida kirganlarning {{with_percent}}% xarid qildi ({{with_days}} kun), qolgan {{other_days}} kunda {{other_percent}}%.",
      "finding_factor": "Yaxshi kunlarda {{factor}} {{good}}, qolgan kunlarda {{rest}}.",
      "observation": "{{count}} kunlik ma'lumotdan taxminiy hisob, va'da emas. Bitta chekka bir necha kishi kelishi mumkin. Ma'lumot ko'paygan sari yangilanadi.",
      "factor": {
        "returning_share": "qaytgan mijozlar ulushi (%)",
        "children_share": "bolalar ulushi (%)",
        "cancelled_share": "kirmay qaytganlar ulushi (%)",
        "discounted_share": "chegirmali cheklar ulushi (%)",
        "items_per_receipt": "bir chekdagi dona soni"
      },
      "actions_title": "Nima qilish kerak",
      "action_busy_hours": "Eng gavjum soatlarda ({{hours}}) eng kuchli sotuvchini zalda qoldiring: kirgan har bir odamga birinchi bo'lib yondashsin.",
      "action_sellers_together": "{{sellers}}ni bir smenaga qo'ying, ayniqsa eng gavjum soatlarda ({{hours}}).",
      "action_sellers_one": "{{sellers}}ni eng gavjum soatlarga qo'ying ({{hours}}).",
      "action_goal": "2 haftalik maqsad: xarid ulushini {{current}}% dan {{target}}% ga chiqaring. Bu oyiga taxminan +{{gain}} tushum.",
      "action_door": "Kuniga o'rtacha {{people}} kishi kirmay qaytmoqda. Eshik oldi va vitrinani ko'rib chiqing: ular kirsa, oyiga yana taxminan +{{gain}} tushum.",
      "seen_sample": "Instagram"
    }
  }
}
